import { twMergeConfig } from '@zeus/themes/next';
import { createTV } from 'tailwind-variants';

const tv = createTV({ twMergeConfig });

export { tv };
